// 表单数据
export const formData = {
    version: '',
    publishTime: '',
    href: '',
    remark: '',
    type: 0,
}

// 表单验证规则
export const formRules = {
    version: [{ required: true, message: "版本不能为空", trigger: "blur" }],
    publishTime: [{ required: true, message: "发布时间不能为空", trigger: "blur" }],
    href: [{ required: true, message: "下载地址不能为空", trigger: "blur" }],
    remark: [{ required: true, message: "升级内容不能为空", trigger: "blur" }],
    type: [{ required: true, message: "客户端类型不能为空", trigger: "blur" }],
}